import { QrParserResult } from '@/common/CodeScanner/parseQrCode'
import { useQrScanner } from '@/common/CodeScanner/useQrScanner'
import InputAction from '@ui/forms/Input/InputAction'
import { useCallback, useEffect } from 'react'
import { Platform } from 'react-native'

const CodeHandler = ({ onSubmit }: { onSubmit: (code: string) => void }) => {
  const close = useQrScanner((s) => s.close)

  const onQrCodeScanned = useCallback(
    (result: QrParserResult) => {
      if (result) {
        close()
        onSubmit(result.code)
      }
    },
    [onSubmit, close]
  )
  const addQrCallback = useQrScanner((s) => s.addCallback)

  useEffect(() => {
    const remove = addQrCallback(onQrCodeScanned)
    return () => {
      remove()
    }
  }, [])

  return null
}

const CodeScannerInput = ({
  onSubmit,
}: {
  onSubmit: (code: string) => void
}) => {
  const openQrScanner = useQrScanner((s) => s.open)

  return (
    <>
      {Platform.OS !== 'web' && (
        <InputAction icon="qr-code" onPress={openQrScanner} />
      )}
      <CodeHandler onSubmit={onSubmit} />
    </>
  )
}

export default CodeScannerInput
